import { createSvgIcon } from '@mui/material';

export const CheckIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="m7.958 15-4.75-4.75 1.188-1.188 3.563 3.563 7.645-7.646 1.188 1.188L7.958 15Z"
    />
  </svg>,
  'CheckIcon',
);
